import Swiper, { Autoplay } from 'swiper';

Swiper.use([Autoplay]);

document.addEventListener('DOMContentLoaded', () => {
    const countElements = document.querySelectorAll('.count-up');

    const startCountUp = (element) => {
        const target = Number(element.dataset.count);
        const duration = 1500;
        const startTime = performance.now();

        const updateCount = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // 終盤でゆっくり止まる動き
            const easedProgress = 1 - Math.pow(1 - progress, 3);
            const currentValue = Math.floor(target * easedProgress);

            element.textContent = currentValue.toLocaleString();

            if (progress < 1) {
                requestAnimationFrame(updateCount);
            } else {
                element.textContent = target.toLocaleString();
            }
        };

        requestAnimationFrame(updateCount);
    };

    const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            startCountUp(entry.target);

            // 1回だけ実行
            observerInstance.unobserve(entry.target);
        });
    }, {
        threshold: 0.2
    });

    countElements.forEach((element) => {
        observer.observe(element);
    });

    new Swiper('.logo-auto-swiper', {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 4000,
        allowTouchMove: false,
    
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
      });

      const toggle = document.querySelector('.publish-nav__toggle');
      const menu = document.querySelector('.navbar-action');
      const menuInner = document.querySelector('.navbar-action-inner');
    
      if (!toggle || !menu || !menuInner) {
        return;
      }
    
      const closeMenu = () => {
        toggle.classList.remove('is-open');
        menu.classList.remove('is-open');
        menuInner.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      };
    
      toggle.addEventListener('click', () => {
        const isOpen = toggle.classList.toggle('is-open');
    
        menu.classList.toggle('is-open', isOpen);
        menuInner.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
      });
    
      menuInner.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', closeMenu);
      });
});